function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './AccountEditYourInterests.css';
import React, { useEffect, useState } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { canUseDOM, get, getDictionaryItem } from '../../utils';
import HobbiesAndTravellersTypeItem from './components/HobbiesAndTravellersTypeComponents/HobbiesAndTravellersTypeItem';
import { getLatestUserCookie, getUserCookie } from './user_session';
import { fetchData } from '../../utils/fetchData';
import { loaderStyles } from './loaderStyles';
const AccountEditYourInterests = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const travelerTypeTitle = get(fields, 'data.datasource.travelerLabel.jss.value') || 'Traveler type';
  const travelerTypeItems = get(fields, 'data.datasource.travelerSections.targetItems') || [];
  const yourInterestsTitle = get(fields, 'data.datasource.interestsLabel.jss.value') || 'Your interests';
  const yourInterestsItems = get(fields, 'data.datasource.interestsSections.targetItems') || [];
  const buttonLabel = get(fields, 'data.datasource.buttonLabel.jss.value') || 'Update interestes';
  const confirmationLabel = get(fields, 'data.datasource.confirmationLabel.jss') || '';
  const dictionaryValues = get(fields, 'data.dictionary');
  const errorMessage = getDictionaryItem(dictionaryValues, 'error');
  const [formResponseError, setFormResponseError] = useState('');
  const [cardTraveler, setCardTraveler] = useState(travelerTypeItems);
  const [cardInterests, setCardInterests] = useState(yourInterestsItems);
  const [initialTravelerActiveIds, setInitialTravelerActiveIds] = useState([]);
  const [chosenTravelerActiveIds, setChosenTravelerActiveIds] = useState([]);
  const [initialInterestsActiveIds, setInitialInterestsActiveIds] = useState([]);
  const [chosenInterestsActiveIds, setChosenInterestsActiveIds] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const onMultyCardsChoose = (key, array, setArrayCallback, setChosenIdsCallback) => {
    const cardHobbiessUpdated = [...array];
    cardHobbiessUpdated.map(el => {
      const id = get(el, 'key.targetItem.id');
      if (id === key) {
        el.active = !el.active;
      }
    });
    setArrayCallback(cardHobbiessUpdated);
    setChosenIdsCallback(cardHobbiessUpdated.filter(el => el.active).map(el => el.key.targetItem.id));
  };
  const onCardChoose = (key, array, setArrayCallback, setChosenIdCallback) => {
    const cardHobbiessUpdated = [...array];
    cardHobbiessUpdated.map(el => {
      const id = get(el, 'key.targetItem.id');
      if (id === key) {
        el.active = true;
      } else {
        el.active = false;
      }
    });
    setArrayCallback(cardHobbiessUpdated);
    setChosenIdCallback(key);
  };
  const clientId = get(sitecoreContext, 'configuration.globalApi.clientId') || 'replaceint2';
  const apiGlobal = get(sitecoreContext, 'configuration.globalApi.apiGlobal') || 'https://replaceapiGlobal';
  const identityGlobal = get(sitecoreContext, 'configuration.globalApi.identityGlobal') || 'https://replaceidentityGlobal';
  const clientSecret = get(sitecoreContext, 'configuration.globalApi.clientSecret') || 'replacesecret';
  const loginStatus = getUserCookie().login_status;
  const loginPageLink = get(fields, 'data.contextItem.loginPage.jss.value.href') || '';
  const onSubmitUpdate = async () => {
    setShowLoader(true);
    setInitialTravelerActiveIds([...chosenTravelerActiveIds]);
    setInitialInterestsActiveIds([...chosenInterestsActiveIds]);
    getLatestUserCookie(identityGlobal, clientId, clientSecret).then(async userCookie => {
      if (userCookie && userCookie.access_token) {
        let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append('Authorization', `Bearer ${userCookie.access_token}`);
        let raw = `{
          "travelerType": ${JSON.stringify(chosenTravelerActiveIds)},
          "interests": ${JSON.stringify(chosenInterestsActiveIds)}
        }`;
        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow'
        };
        let statusCode = 0;
        await fetch(`${identityGlobal}/api/user/UpdateInterests`, requestOptions).then(response => {
          statusCode = response.status;
          return response.text();
        }).then(result => {
          let responseObj;
          if (result) {
            responseObj = JSON.parse(result);
          }
          if (statusCode === 200) {
            if (responseObj.isSuccess) {
              // showSuccessToast();
            } else if (!responseObj.isSuccess) {
              if (responseObj.errors && responseObj.errors.length) {
                throw Error(responseObj.errors[0].code);
              }
            }
          } else if (statusCode === 400) {
            if (responseObj.errors && responseObj.errors.length) {
              throw Error(responseObj.errors[0].code);
            }
          } else {
            throw Error(errorMessage);
          }
        }).catch(error => {
          if (statusCode === 0) {
            setFormResponseError(errorMessage);
          } else {
            setFormResponseError(error.message);
          }
        }).finally(() => {
          setShowLoader(false);
        });
      }
    }).catch(error => {
      setShowLoader(false);
      console.error('fetchData error', error);
    });
  };
  useEffect(() => {
    if (!process.env.STORYBOOK_MODE) {
      if (canUseDOM) {
        if (!loginStatus) {
          window.location.href = window.location.origin + loginPageLink;
        } else {
          getLatestUserCookie(identityGlobal, clientId, clientSecret).then(userCookie => {
            if (userCookie && userCookie.access_token) {
              setShowLoader(true);
              fetchData({
                path: `${apiGlobal}/graphql/user`,
                options: {
                  method: 'POST',
                  body: JSON.stringify({
                    query: `{ userProfile { travelerType, interests } }`
                  })
                },
                authToken: userCookie.access_token
              }).then(data => {
                const {
                  travelerType,
                  interests
                } = data.data.userProfile;
                if (travelerType && travelerType.length) {
                  const travelerTypeIds = parseGuidArray(travelerType);
                  setInitialTravelerActiveIds(travelerTypeIds);
                  setChosenTravelerActiveIds(travelerTypeIds);
                  setCardTraveler(prevElements => prevElements.map(element => travelerTypeIds.includes(parseGuidString(element.key.targetItem.id)) ? _objectSpread(_objectSpread({}, element), {}, {
                    active: true
                  }) : element));
                }
                if (interests && interests.length) {
                  const interestsIds = parseGuidArray(interests);
                  setInitialInterestsActiveIds(interestsIds);
                  setChosenInterestsActiveIds(interestsIds);
                  setCardInterests(prevElements => prevElements.map(element => interestsIds.includes(parseGuidString(element.key.targetItem.id)) ? _objectSpread(_objectSpread({}, element), {}, {
                    active: true
                  }) : element));
                }
              }).catch(error => {
                console.error('fetchData error', error);
              }).finally(() => {
                setShowLoader(false);
              });
            }
          }).catch(error => {
            setShowLoader(false);
            console.error('fetchData error', error);
          });
        }
      }
    }
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "user-interests"
  }, /*#__PURE__*/React.createElement("div", {
    className: "user-interests__section"
  }, travelerTypeTitle && /*#__PURE__*/React.createElement("h3", {
    className: "user-interests__title"
  }, travelerTypeTitle), cardTraveler.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "user-interests__items"
  }, cardTraveler.map((item, index) => {
    const id = get(item, 'key.targetItem.id');
    const title = get(item, 'title.jss.value');
    const icon = get(item, 'interestIconCode.jss.value');
    const isActive = item.active;
    return /*#__PURE__*/React.createElement(HobbiesAndTravellersTypeItem, {
      key: `${id}_${index}`,
      id: id,
      title: title,
      isActive: isActive,
      icon: icon,
      carouselView: false,
      handleClick: () => {
        onMultyCardsChoose(id, cardTraveler, setCardTraveler, setChosenTravelerActiveIds);
      }
    });
  }))), /*#__PURE__*/React.createElement("div", {
    className: "user-interests__section"
  }, yourInterestsTitle && /*#__PURE__*/React.createElement("h3", {
    className: "user-interests__title"
  }, yourInterestsTitle), cardInterests.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "user-interests__items"
  }, cardInterests.map((item, index) => {
    const id = get(item, 'key.targetItem.id');
    const title = get(item, 'title.jss.value');
    const icon = get(item, 'interestIconCode.jss.value');
    const isActive = item.active;
    return /*#__PURE__*/React.createElement(HobbiesAndTravellersTypeItem, {
      key: `${id}_${index}`,
      id: id,
      title: title,
      isActive: isActive,
      icon: icon,
      carouselView: false,
      handleClick: () => {
        onMultyCardsChoose(id, cardInterests, setCardInterests, setChosenInterestsActiveIds);
      }
    });
  }))), (travelerTypeItems.length > 0 || yourInterestsItems.length > 0) && /*#__PURE__*/React.createElement("div", {
    className: "w-100"
  }, /*#__PURE__*/React.createElement("p", {
    className: "privacy-policy",
    dangerouslySetInnerHTML: {
      __html: confirmationLabel
    }
  }), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary submit-btn",
    type: "submit",
    disabled: setsEqual(initialTravelerActiveIds, chosenTravelerActiveIds) && setsEqual(initialInterestsActiveIds, chosenInterestsActiveIds),
    onClick: () => {
      if (!setsEqual(initialTravelerActiveIds, chosenTravelerActiveIds) || !setsEqual(initialInterestsActiveIds, chosenInterestsActiveIds)) {
        onSubmitUpdate();
      }
    }
  }, buttonLabel), formResponseError && formResponseError.length ? /*#__PURE__*/React.createElement("div", {
    className: "lr__error"
  }, formResponseError) : null), /*#__PURE__*/React.createElement("div", {
    className: "loader-t1",
    style: {
      display: `${showLoader ? 'flex' : 'none'}`
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "loadingio-spinner-rolling-arlp0sgzkfu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ldio-fryp34cx4ij"
  }, /*#__PURE__*/React.createElement("div", null))))));
};
const rtlStyles = "rqc9mlb";
const ltrStyles = "l1frd3bx";
const commonStyles = "cco2jvl";
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    removePaddingTop: true,
    className: `${loaderStyles} ${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const setsEqual = (arr1, arr2) => {
  const set1 = new Set(arr1);
  const set2 = new Set(arr2);
  return set1.size === set2.size && [...set1].every(item => set2.has(item));
};
const stringsEqual = (str1, str2) => {
  return str1 === str2;
};
const parseGuidString = guid => {
  return guid.replace(/-/g, '').toLowerCase().trim();
};
const parseGuidArray = guidArray => {
  return guidArray.map(guid => parseGuidString(guid));
};
export default AccountEditYourInterests;